import { DEFAULT_PAGINATION, DEFAULT_SORT_BY, SORTING_TYPE } from '../../../../constants';
import { SCOPE_OPTIONS } from './AddFilter/select-options';
import {
     ADD_FILTER_COMPONENT,
     ADD_MULTI_FILTER_COMPONENT,
     CHANGE_FILTER_COMPONENT,
     CHANGE_SCOPE_OPTIONS,
     DELETE_FILTER_COMPONENT,
     DESIGNATION_ELEMENT_REPORT_RESULTS,
     GET_DESIGNATION_ELEMENT_OPTIONS,
     LOADING_DESIGNATION_REPORTS,
     RESET_DESIGNATION_ELEMENT_REPORTS,
     SET_PAGINATION_DESIGNATION_REPORTS,
     SET_SORT_DESIGNATION_REPORTS,
} from './actions';

const initialState = {
     filterComponents: [
          {
               id: 0,
               key: 'certificationLevel',
               value: '',
               label: '',
               isEdit: true,
               hasAccessElement: [],
               elementStatus: [],
               comparison: 'eq',
          },
     ],
     designationElementOptions: [],
     scopeOptions: SCOPE_OPTIONS,
     results: null,
     isLoading: false,
     pagination: {
          page: DEFAULT_PAGINATION.PAGE,
          pageSize: DEFAULT_PAGINATION.PAGE_SIZE,
     },
     sort: {
          sortBy: DEFAULT_SORT_BY.CREATED_AT,
          sortType: SORTING_TYPE.DESC_NULL_LAST,
     },
};

const designationReportsReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_FILTER_COMPONENT: {
               const filterComponents = [...state.filterComponents];
               const index = filterComponents.findIndex((item) => item.key === action.payload.key);

               if (index !== -1) {
                    filterComponents[index] = action.payload;
               } else {
                    filterComponents.push(action.payload);
               }

               return {
                    ...state,
                    filterComponents,
               };
          }
          case DELETE_FILTER_COMPONENT: {
               const filterComponents = [...state.filterComponents];
               const deleteIndex = filterComponents.findIndex((filter) => filter.id === action.payload);

               if (deleteIndex !== -1) {
                    filterComponents.splice(deleteIndex, 1);
               }

               return {
                    ...state,
                    filterComponents,
               };
          }

          case CHANGE_FILTER_COMPONENT: {
               const filterComponents = [...state.filterComponents];
               const indexChange = filterComponents.findIndex((filter) => filter.id === action.payload.id);

               if (indexChange !== -1) {
                    filterComponents[indexChange] = action.payload;
               }

               return {
                    ...state,
                    filterComponents,
               };
          }

          case GET_DESIGNATION_ELEMENT_OPTIONS: {
               return {
                    ...state,
                    designationElementOptions: action.payload,
               };
          }

          case CHANGE_SCOPE_OPTIONS: {
               return {
                    ...state,
                    scopeOptions: action.payload,
               };
          }

          case ADD_MULTI_FILTER_COMPONENT: {
               return {
                    ...state,
                    filterComponents: action.payload,
               };
          }

          case DESIGNATION_ELEMENT_REPORT_RESULTS: {
               return {
                    ...state,
                    results: action.payload,
               };
          }

          case RESET_DESIGNATION_ELEMENT_REPORTS: {
               const filterComponents = [...initialState.filterComponents];

               const userFilterComponent = state.filterComponents.find((filter) => filter.key === 'user');
               const orgFilterComponent = state.filterComponents.find((filter) => filter.key === 'organization');

               if (userFilterComponent) {
                    filterComponents.push(userFilterComponent);
               }

               if (orgFilterComponent) {
                    filterComponents.push(orgFilterComponent);
               }

               return {
                    ...initialState,
                    filterComponents,
                    designationElementOptions: state.designationElementOptions,
               };
          }

          case LOADING_DESIGNATION_REPORTS: {
               return {
                    ...state,
                    isLoading: action.payload,
               };
          }

          case SET_PAGINATION_DESIGNATION_REPORTS: {
               return {
                    ...state,
                    pagination: {
                         ...state.pagination,
                         ...action.payload,
                    },
               };
          }

          case SET_SORT_DESIGNATION_REPORTS: {
               return {
                    ...state,
                    sort: {
                         ...state.sort,
                         ...action.payload,
                    },
               };
          }

          default:
               return state;
     }
};

export default designationReportsReducer;
